<template>
  <IndexPageSection
    :need-link="false"
    :need-to-move-link-to-bottom="false"
    :section-name="'receiving-kinds'"
    :title="receivingKindsTitle"
  >
    <div class="receiving-kind__boxes">
      <receivingKindBox
        v-for="receivingKind in receivingKinds"
        :key="receivingKind.id"
        :receiving-kind-id="receivingKind.id"
        :receiving-kind-name="receivingKind.name"
        :receiving-kind-icon="receivingKind.icon"
      />
    </div>
  </IndexPageSection>
</template>

<script>
import IndexPageSection from './IndexPageSection.vue'
import receivingKindBox from './receiving_kinds/receivingKindBox.vue'
import home from '../../../../../../images/icons/store.svg'
import globe from '../../../../../../images/icons/globe.svg'
import car from '../../../../../../images/icons/car.svg'
import axios from 'axios'

export default {
  components: {
    IndexPageSection,
    receivingKindBox
  },
  data() {
    return {
      receivingKindsTitle: '受け取り方法から探す',
      receivingKinds: []
    }
  },
  mounted() {
    this.getItemReceivingKinds()
  },
  methods: {
    async getItemReceivingKinds() {
      try {
        const res = await axios.get('/api/v1/pickup/item_receiving_kinds')
        this.receivingKinds = res.data.data.map(receivingKind => {
          const id = receivingKind.attributes.id
          const name = receivingKind.attributes.displayName
          switch (receivingKind.attributes.name) {
            case 'pick_up':
              return {
                id,
                name,
                icon: home
              }
            case 'external_site_use':
              return {
                id,
                name,
                icon: globe
              }
            case 'delivery':
              return {
                id,
                name,
                icon: car
              }
            default:
              console.error('unexpected receiving kind.', receivingKind)
          }
        })
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', errorMessage)
      }
    }
  }
}
</script>
